<template>
  <Tooltip :text="tooltip" :hide-delay="200">
    <div
      class="btn-group btn-group-sm debug-locale-switcher"
      role="group"
      :aria-label="groupLabel"
    >
      <button
        type="button"
        class="btn btn-outline-secondary"
        :class="{ active: current === 'ru' }"
        :aria-pressed="current === 'ru'"
        :aria-label="t('ruButtonHint')"
        :title="t('ruButtonHint')"
        @click="setLocale('ru')"
      >
        RU
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        :class="{ active: current === 'en' }"
        :aria-pressed="current === 'en'"
        :aria-label="t('enButtonHint')"
        :title="t('enButtonHint')"
        @click="setLocale('en')"
      >
        EN
      </button>
    </div>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Tooltip from '@/components/tooltip.vue'
import { i18n } from '@/i18n'
import { persistUserLocalePreference } from '@/i18n/localeStorage.js'
import { useUserStore } from '@/stores/user'

const { t } = useI18n()
const userStore = useUserStore()
const current = computed(() => i18n.global.locale.value)

function setLocale(code) {
  i18n.global.locale.value = persistUserLocalePreference(userStore.user?.id, code)
}

const tooltip = computed(() => t('tooltip'))
const groupLabel = computed(() => t('groupLabel'))
</script>

<i18n>
{
  "ru": {
    "tooltip": "Язык интерфейса",
    "groupLabel": "Язык интерфейса",
    "enButtonHint": "English term",
    "ruButtonHint": "Russian translation"
  },
  "en": {
    "tooltip": "Interface language",
    "groupLabel": "Interface language",
    "enButtonHint": "English term",
    "ruButtonHint": "Russian translation"
  }
}
</i18n>

<style scoped>
.debug-locale-switcher .btn {
  color: rgba(255, 255, 255, 0.75);
  border-color: rgba(255, 255, 255, 0.25);
  background: transparent;
}

.debug-locale-switcher .btn:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.1);
}

.debug-locale-switcher .btn.active,
.debug-locale-switcher .btn.active:hover,
.debug-locale-switcher .btn.active:focus,
.debug-locale-switcher .btn.active:active {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.22) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  box-shadow: none;
}
</style>
